
var jsCookies = require('js-cookie');

var countryMap = [
		// asia
		{
			phone: '+65 6842 1419',
			countryCodes: ['AF','AM','AZ','BH','BD','BT','BN','KH','CN','GE','HK','IN','ID','IR','IQ','JP','JO','KZ','KW','KG','LA','LB','MO','MY','MV','MN','MM','NP','KP','OM','PK','PH','QA','SA','SG','KR','LK','SY','TW','TJ','TH','TM','AE','UZ','VN','YE']
		},

		// india
		{
			phone: '+91 20 2469 9910',
			countryCodes: ['IN']
		},

		// france (europe + russia)
		{
			phone: '+33 5 62 63 44 91',
			countryCodes: ['AE','AL','AD','AT','BY','BE','BA','BG','HR','CY','CZ','IL','DK','EE','FO','FI','FR','DE','GI','GR','HU','IS','IE','IM','IT','XK','LV','LI','LT','LU','MK','MT','MD','MC','ME','NL','NO','PL','PT','RO','RU','SM','TR','RS','SK','SI','ES','SE','CH','UA','GB','VA','ZA']
		},
	],

	// US and everything else
	defaultNumber = '+1 800 641 4054';

function init(){

	var savedNumber = jsCookies.get('posi-country-phone-number');

	if(savedNumber && savedNumber.length > 0)
		return setCurrentUserNumber(savedNumber, true);

  	var countryCode = SITE_SETTINGS.curCountryCode,
  		foundNumber = false;

  	// emulate find method to find country code
  	$.each(countryMap, function(i, countrySet){
  		$.each(countrySet.countryCodes, function(i, curCountryCode){
  			if(countryCode != curCountryCode)
  				return;

  			foundNumber = countrySet.phone;
  			return false;
  		});

  		if(foundNumber !== false)
  			return false; // exit loop
  	});

  	if(foundNumber == false)
  		foundNumber = defaultNumber;

  	setCurrentUserNumber(foundNumber);

}

function setCurrentUserNumber(phoneNumber, skipCookieSave){

	if(!skipCookieSave)
		jsCookies.set('posi-country-phone-number', phoneNumber, { expires: 1 });

	$('.location-based-phone-number').text(phoneNumber)
		.removeClass('hide')
		.filter('a')
		.attr('href', 'tel:' + phoneNumber);

}

init();

